<template>
    <div class="nav-root mb-2 px-2">
        <div class="nav-layout d-flex">
            <!--//////////only for mobile view////////-->
            <div class="mobile-menu">
                <NavLinkIcon :to="cockpitRoute()" icon="user" />
                <NavLinkIcon :to="favoritesRoute()" icon="heart" />
                <NavLinkIcon :to="spotlightRoute()" icon="user-graduate" />
                <NavLinkIcon :show="hasAssessments" :to="testsRoute()" icon="clipboard-check" />
                <NavLinkIcon
                    :show="hasInternalResources"
                    :to="internalResourcesRoute()"
                    icon="file-alt"
                />
                <NavLinkIcon :show="hasCalendar" :to="calendarRoute()" icon="calendar-alt" />
            </div>
            <!--//////////only for desktop view////////-->
            <NavLink
                v-if="hasMyPage"
                class="nav-item"
                :to="cockpitRoute()"
                :label="$t('shared.userNavSection.myPage')"
                exact
            />
            <NavLink
                v-if="hasFavourites"
                class="nav-item"
                :to="favoritesRoute()"
                :label="$t('shared.userNavSection.myFavorites')"
            />
            <NavLink
                class="nav-item"
                :to="spotlightRoute()"
                :label="$t('shared.userNavSection.myProfile')"
            />

            <NavLink
                v-if="hasAssessments"
                class="nav-item"
                :to="testsRoute()"
                :label="$t('shared.userNavSection.myTests')"
            />

            <NavLink
                v-if="hasInternalResources"
                class="nav-item"
                :to="internalResourcesRoute()"
                :label="$t('shared.userNavSection.internalResources')"
            />

            <NavLink
                v-if="hasCalendar"
                class="nav-item"
                :to="calendarRoute()"
                :label="$t('shared.userNavSection.calendar')"
            />
        </div>
    </div>
</template>

<script>
import NavLink from '~/components/navigation/NavLink';
import NavLinkIcon from '~/components/navigation/NavLinkIcon';
import ResourceService from '~/services/ResourceService';
import UniversityService from '~/services/UniversityService';
import {
    HAS_ASSESSMENTS,
    HAS_CALENDAR,
    HAS_INTERNAL_RESOURCES,
    HAS_MY_PAGE,
    HAS_FAVOURITES,
} from '~/router';

export default {
    name: 'UserNavSection',
    components: { NavLink, NavLinkIcon },
    data: function() {
        return {
            hasInternalResources: false,
            hasCalendar: false,
            hasAssessments: HAS_ASSESSMENTS,
            hasFavourites: HAS_FAVOURITES,
            hasMyPage: HAS_MY_PAGE,
        };
    },
    mounted() {
        // Always show resources as long the CV template is there
        this.hasInternalResources = HAS_INTERNAL_RESOURCES;
        /*  ResourceService.hasResources().then(result => {
            this.hasInternalResources = result && HAS_INTERNAL_RESOURCES;
        }); */
        UniversityService.hasCalendar().then(doesIt => {
            this.hasCalendar = doesIt && HAS_CALENDAR;
        });
    },
    methods: {
        cockpitRoute: function() {
            return this.$URLS.mypage;
        },
        favoritesRoute: function() {
            return this.$URLS.favorites;
        },
        spotlightRoute: function() {
            return this.$URLS.spotlight;
        },
        testsRoute: function() {
            return this.$URLS.tests;
        },
        internalResourcesRoute: function() {
            return this.$URLS.internalResources;
        },
        calendarRoute: function() {
            return this.$URLS.calendar.concat(this.$URLS.book);
        },
        isProd() {
            // eslint-disable-next-line no-undef
            return IS_PROD;
        },
    },
};
</script>

<style scoped>
.mobile-menu {
    display: none;
}
.nav-root {
    max-width: var(--grid-width);
    height: 26px;
    margin: auto;
}
.nav-item {
    color: rgba(255, 255, 255, 0.9);
    margin-right: 42px;
    height: 100%;
    padding: 0;
    z-index: 2;
    float: left;
}
.nav-layout {
    height: 100%;
}
.activeClass {
    border-bottom: 2px solid white;
    color: white;
}

@media only screen and (max-width: 600px) {
    .mobile-menu {
        display: flex;
        width: 100%;
        font-size: 19px;
    }

    .nav-item {
        margin-right: 18px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        flex-basis: auto;
        width: fit-content;
        display: none;
    }

    .activeClass {
        max-width: min-content;
        flex-shrink: 0;
    }
}
</style>
